class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.summaryToggle = this.mainDetailsToggle.querySelector('summary');
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    // Keep aria-expanded in sync however the disclosure is opened (keyboard
    // toggle, hover, arrow keys).
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
    this.submenu = this.querySelector('.header__submenu');

    this.submenuLinks = this.querySelectorAll('[data-header-submenu-link]');
    this.submenuLinks.forEach((submenuLink) => {
      submenuLink.addEventListener('click', (event) => {
        let target = event.target;
        let index = target.dataset.headerSubmenuLink;
        let parent = target.closest('.header__submenu-title');
        let tabs = parent.nextElementSibling;
        let tab = tabs.querySelector('[data-header-submenu-tab="'+index+'"]');
        parent.querySelectorAll('[data-header-submenu-link]').forEach((el) => {el.classList.remove('active')});
        tabs.querySelectorAll('[data-header-submenu-tab]').forEach((el) => {el.classList.remove('active')});
        target.classList.add('active');
        tab.classList.add('active');
      });
    });
    // NOTE: hover-open is handled by StickyHeader's mouseenter listener
    // (sections/header.liquid). A mousemove listener here used to also force
    // the menu open, but it re-opened the menu immediately after a keyboard
    // close (focusout/Escape) whenever the pointer rested over the menu item —
    // browsers fire synthetic mouse events when layout changes under a
    // stationary cursor. Do not re-add it.
  }

  onToggle() {
    this.summaryToggle.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open'));
  }

  // Arrow-key navigation (WAI-ARIA disclosure navigation pattern):
  // - ArrowDown/ArrowUp on the top-level item opens the submenu and moves
  //   focus to its first/last link.
  // - ArrowDown/ArrowUp inside the submenu moves between links; ArrowUp from
  //   the first link returns focus to the top-level item.
  onKeyDown(event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    if (!this.submenu) return;

    const links = Array.from(this.submenu.querySelectorAll('a[href]'));
    if (!links.length) return;

    if (event.target === this.summaryToggle) {
      event.preventDefault();
      this.mainDetailsToggle.setAttribute('open', '');
      (event.key === 'ArrowDown' ? links[0] : links[links.length - 1]).focus();
    } else {
      const index = links.indexOf(event.target);
      if (index === -1) return;
      event.preventDefault();
      if (event.key === 'ArrowDown') {
        if (index < links.length - 1) links[index + 1].focus();
      } else {
        if (index > 0) {
          links[index - 1].focus();
        } else {
          this.summaryToggle.focus();
        }
      }
    }
  }

  onFocusOut(event) {
    // relatedTarget is the element receiving focus — check it synchronously so
    // the menu closes the moment focus tabs out, regardless of what other
    // scripts do with focus afterwards.
    if (event.relatedTarget && !this.contains(event.relatedTarget)) {
      this.close();
      return;
    }
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
